import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { AppLogoStatic } from '../components/AppLogo';

const SECTIONS = [
  { h: '1. Information We Collect', p: 'We collect the information you choose to store in your legacy vault — such as photos, videos, documents, messages, and contact details — along with basic account information (name, email) needed to provide the service.' },
  { h: '2. How We Use Your Information', p: 'Your information is used solely to operate EasyPassing: storing your content securely, enabling access for the trusted contacts you designate, and communicating with you about your account. We never sell your personal data.' },
  { h: '3. Data Security', p: 'We protect your data with encrypted storage, secure login, optional multi-factor authentication, and secure cloud backups. Your vault is private by default, and you control who can access it.' },
  { h: '4. Who Can Access Your Information', p: 'Only you can access your vault unless you explicitly grant access to trusted contacts or beneficiaries. You decide what they can see and when that access is released.' },
  { h: '5. Your Rights & Control', p: 'You may access, update, export, or delete your information at any time. If you cancel your account, we give you the opportunity to download your data before it is removed.' },
  { h: '6. Cookies & Analytics', p: 'We use minimal, privacy-respecting analytics to improve the service. We do not use your personal content for advertising.' },
  { h: '7. Contact Us', p: 'Questions about your privacy? Reach out anytime through the contact form on our homepage.' },
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" sections={SECTIONS} intro="Your information belongs to you. This policy explains what we collect, how we protect it, and the control you have over your legacy vault." />;
}

export function LegalPage({ title, sections, intro }) {
  return (
    <div className="font-body min-h-screen bg-[#FDFBF7] text-slate-800">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-logo">
            <AppLogoStatic size="sm" showText={false} />
            <span className="font-display text-xl font-bold text-[#2B4C7E]">EasyPassing</span>
          </Link>
          <Link to="/" className="text-sm font-semibold text-[#2B4C7E] flex items-center gap-1 hover:underline" data-testid="legal-back">
            <ArrowLeft className="h-4 w-4" /> Back to Home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-4xl font-bold text-[#1C252E]">{title}</h1>
        <p className="mt-4 text-slate-600 leading-relaxed">{intro}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl font-bold text-[#2B4C7E] mb-2">{s.h}</h2>
              <p className="text-slate-600 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
        <p className="mt-12 text-sm text-slate-400">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </main>
    </div>
  );
}
